<template>
  <div>
    <component
      :is="componentType"
      :additional-property-types="additional_property_types"
      :colors="colors"
      :label-colors="labelColors"
      :customer="customer"
      :items="items"
      :requirements="requirements"
      :property-types="property_types"
      :target-types="target_types"
      @save="createNewSearchWatch"
      @loading="$emit('loading', $event)"
    />
    <v-bottom-navigation
      v-if="type === 'filter'"
      :input-value="showBottomNavigation"
      color="primary"
      fixed
    >
      <v-btn @click="showFilters">
        <span>Hakuvahdin kriteerit</span>
        <v-icon>search</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <v-overlay
      color="white"
      opacity="0.85"
      :value="overlay"
      :class="{ 'in-iframe': isInIFrame }"
    >
      <v-card
        color="transparent"
        flat
        light
      >
        <v-row class="text-center">
          <v-col cols="12">
            <v-avatar
              color="primary"
              size="98"
            >
              <v-icon color="white" size="64">
                check
              </v-icon>
            </v-avatar>
          </v-col>
          <v-col cols="12" class="">
            <p class="text-h4">
              Hakuvahti tallennettu
            </p>
          </v-col>
        </v-row>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { isAnObject, EventBus } from '@/utils';
import {
  additional_property_types,
  requirements,
  property_types,
  target_types,
} from '@/components/searchWatch/data';

export default {
  name: 'HelmiSearchWatch',

  components: {
    'helmi-search-watch-form': () => import('@/components/searchWatch/SearchWatchForm'),
    'helmi-search-watch-filter': () => import('@/components/searchWatch/SearchWatchFilter'),
  },

  props: {
    type: {
      type: String,
      default: 'filter', // either 'form' or 'filter
    },
  },

  data: () => ({
    create: false,
    color: 'primary',
    labelColor: 'grey darken-1',
    customer: {
      name: '',
      email: '',
      phone: '',
    },
    items: {
      target_type: null,
      property_types: [],
      rooms: {
        rooms_min: 0,
        rooms_max: 10,
      },
      area: {
        area_min: 0,
        area_max: 500,
      },
      price: {
        price_min: 0,
        price_max: 1000000,
      },
      requirements: [],
      cities: [],
    },
    overlay: false,
    additional_property_types,
    requirements,
    property_types,
    target_types,
  }),

  computed: {
    colors() {
      const colors = this.color.split(' ');
      return this.createColors(colors);
    },

    labelColors() {
      const colors = this.labelColor.split(' ');
      return this.createColors(colors);
    },

    componentType() {
      return `helmi-search-watch-${this.type}`;
    },

    isInIFrame() {
      return this.$route.name === 'searchWatchForm';
    },

    showBottomNavigation() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },

  methods: {
    ...mapActions({
      createWatch: 'searchWatch/create',
    }),

    createColors(colors) {
      const isShade = c => c.includes('lighten') || c.includes('darken');
      const baseValues = [];
      const textValues = [];

      for (const color of colors) {
        baseValues.push(color);
        textValues.push(isShade(color) ? `text--${color}` : `${color}--text`);
      }

      return {
        base: baseValues.join(' '),
        text: textValues.join(' '),
      };
    },

    async createNewSearchWatch(params) {
      const watch = Object.entries(params.items)
        .reduce((items, [key, item]) => {
          if (isAnObject(item)) {
            // eslint-disable-next-line no-param-reassign
            items = { ...items, ...item };
            return items;
          }

          if (key === 'property_types') {
            // eslint-disable-next-line no-param-reassign
            items[key] = item.filter(i => i !== 'other');

            return items;
          }
          // eslint-disable-next-line no-param-reassign
          items[key] = item;
          return items;
        }, {});

      const data = {
        watch,
        customer: params.customer,
        companyId: params.companyId,
      };

      await this.createWatch({ data, mutate: false });

      this.displayOverlay();

      this.create = false;
    },

    displayOverlay() {
      this.overlay = true;

      setTimeout(() => {
        EventBus.$emit('FORM_RESET');
        this.overlay = false;
      }, 3000);
    },

    showFilters() {
      EventBus.$emit('SHOW_FILTERS');
    },
  },
};
</script>

<style lang="scss">
.helmi-search-watch {}

.v-overlay {
  &.in-iframe {
    align-items: flex-end !important;
    margin-bottom: -16px;
  }
}
</style>
